import { render } from "./EditorSaveDialog.vue?vue&type=template&id=061b8440&ts=true"
import script from "./EditorSaveDialog.vue?vue&type=script&lang=ts"
export * from "./EditorSaveDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__